import { ApplicationTypes, CountersinkHole, attachComponent, featureLabels } from 'metalworks-domain'

import { detailComponent, entityHeaderComponent, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { CountersinkHolePropertyPage } from '../ui/property-pages/CountersinkHolePropertyPage'

export const countersinkHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('CountersinkHole')
    .attach(self => {
      return {
        title: featureLabels[CountersinkHole.type],
        subtitle:
          self.topRadius > 0
            ? `Ø\u00a0${self.topRadius * 2}mm, 90°\u00a0countersink, Ø\u00a0${self.bottomRadius * 2}mm through`
            : `There's no countersink hole type available for currently selected plate.`,
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/countersink-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('CountersinkHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <CountersinkHolePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('CountersinkHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
]
